<template>
  <PageTemplate title="Política de Privacidade" :loading="loading">
    <template #before>
      <router-link to="/" class="d-flex justify-center mb-12">
        <img
          :src="files + informations.img"
          height="40px"
          class="filter-white"
          alt=""
        />
      </router-link>
    </template>

    <PolicyPrivacyWidget class="mt-6 mt-sm-8 mt-lg-10" />
  </PageTemplate>
</template>

<script>
import PageTemplate from "../components/templates/PageTemplate.vue";
import PolicyPrivacyWidget from "../components/widgets/PolicyPrivacyWidget.vue";

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
  },
  mounted() {
    this.loading = false;
  },
  components: {
    PageTemplate,
    PolicyPrivacyWidget,
  },
};
</script>

<style></style>
